import { listSellerInfos } from "@/graphql/queries";
import { useAppDispatch } from "@/store/hooks";
import { setDistributorInfo  } from "@/store/slices/authSlice";
import { SellerInfo } from "@/types/AppTypes";
import { executeGraphQLMutation } from "@/utils/helper/graphql-helper";
import ls from "@/utils/SecureLS";
import { useState } from "react";

export const useSellerInfo = () => {
  const userLs = ls.get("user");
  const user = JSON.parse(userLs);
  const dispatch = useAppDispatch();
  const [sellerInfo, setSellerInfo] = useState<SellerInfo | null>(null);

  const fetchSellerInfo = async () => {
    const sellerInfo = await executeGraphQLMutation({
      query: listSellerInfos,
      variables: {
        filter: {
          user_id: {
            eq: user?.user_id,  
          },
        },
      },
    });

 

    if (sellerInfo?.items?.length > 0) {
      dispatch(setDistributorInfo(sellerInfo?.items[0]));
      setSellerInfo(sellerInfo?.items[0]);
    }

    setSellerInfo(null);
  };
  return {
    sellerInfo,
    fetchSellerInfo,
  };
};
